export var BASE_URL = 'https://app.typeface.ai';
export var TypefaceEmbedUseCase;
(function (TypefaceEmbedUseCase) {
    TypefaceEmbedUseCase["JobPost"] = "Job Post";
    TypefaceEmbedUseCase["Image"] = "Image";
    TypefaceEmbedUseCase["Text"] = "Text";
    TypefaceEmbedUseCase["Template"] = "Templates";
    TypefaceEmbedUseCase["AIInsights"] = "AI Insights";
    TypefaceEmbedUseCase["TPIChat"] = "TPIChat";
    TypefaceEmbedUseCase["ChooseDocument"] = "ChooseDocument";
    TypefaceEmbedUseCase["Default"] = "Default"; // navigate to the default page of the source app
})(TypefaceEmbedUseCase || (TypefaceEmbedUseCase = {}));
export var EMAIL_TEMPLATE = 'dp_email';
export var GOOGLE_AD_TEMPLATE = 'dp_google_ad';
export var TypefaceEmbedIDP;
(function (TypefaceEmbedIDP) {
    TypefaceEmbedIDP[TypefaceEmbedIDP["Typeface"] = 0] = "Typeface";
    TypefaceEmbedIDP[TypefaceEmbedIDP["Okta"] = 1] = "Okta";
})(TypefaceEmbedIDP || (TypefaceEmbedIDP = {}));
export var TypefaceEmbedOutputFormat;
(function (TypefaceEmbedOutputFormat) {
    TypefaceEmbedOutputFormat["HTML"] = "html";
    TypefaceEmbedOutputFormat["JSON"] = "json";
    TypefaceEmbedOutputFormat["BLOCKS"] = "blocks-v1";
    TypefaceEmbedOutputFormat["VARIATIONS"] = "variations-v1";
})(TypefaceEmbedOutputFormat || (TypefaceEmbedOutputFormat = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["JobPost"] = "dp_job_description";
    TemplateType["BlogPost"] = "dp_blog_post";
    TemplateType["Email"] = "dp_email";
    TemplateType["ImageStudio"] = "dp_image_studio";
    TemplateType["TextBlend"] = "dp_text_refiner";
    TemplateType["GoogleAd"] = "dp_google_ad";
    TemplateType["GoogleResponsiveAd"] = "dp_google_responsive_ad";
    TemplateType["CelebrationPost"] = "dp_celebrations_post";
})(TemplateType || (TemplateType = {}));
export var TextBlendActionTypes;
(function (TextBlendActionTypes) {
    TextBlendActionTypes["Summarize"] = "Summarize the content";
    TextBlendActionTypes["Rewrite"] = "Rewrite the content";
    TextBlendActionTypes["Expand"] = "Make longer";
    TextBlendActionTypes["Condense"] = "Make shorter";
})(TextBlendActionTypes || (TextBlendActionTypes = {}));
